export default __webpack_public_path__ + "static/media/victor.fcbca8a3.png";